// SUBSCRIPTION: the organisation has not paid yet. ACCESS: the page is not the user's.
const UNAUTHORIZED_REASONS = {
  SUBSCRIPTION: 'subscription',
  ACCESS: 'access',
}

export default UNAUTHORIZED_REASONS
